module.exports = __webpack_public_path__ + "img/paymentmethod.d69f3b85.png";